import { EXECUTIVE_REQUISITION } from "./actionType";

const initialState = {
    requisitionData: [],

};

const executive = (state = initialState, action) => {

  switch (action.type) {
    case EXECUTIVE_REQUISITION:
       state = {
            ...state,
            requisitionData: action.payload.storedRows,
            productCategory: action.payload.productCategory
          };
      break;  
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default executive;
